import { render, staticRenderFns } from "./SmartStickyHeader.vue?vue&type=template&id=4afc7adc&scoped=true"
import script from "./SmartStickyHeader.vue?vue&type=script&lang=js"
export * from "./SmartStickyHeader.vue?vue&type=script&lang=js"
import style0 from "./SmartStickyHeader.vue?vue&type=style&index=0&id=4afc7adc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afc7adc",
  null
  
)

export default component.exports